import { useMemo } from 'react';

export default function useDefinitions() {
  return useMemo(() => ({
    entityName: 'Site',
    entityNamePlural: 'Sites',
    entityNameModule: 'admin',
  }), [])
}
